<template>
  <div class="card centered">
    <div class="card-header">
      <b-loading
        :is-full-page="true"
        :active.sync="isLoading"
        :can-cancel="false"
      ></b-loading>
      <p class="card-header-title">
        {{ isNew ? $t('mtetype_create_title') : $t('mtetype_update_title') }}
      </p>
    </div>
    <div class="card-content">
      <b-field :label="$t('name')">
        <b-input v-model="mteType.name"></b-input>
      </b-field>
      <div class="card-content-row">
        <b-field :label="$t('needs_master')">
          <b-checkbox v-model="mteType.needsMaster" />
        </b-field>
        <b-field :label="$t('is_master')">
          <b-checkbox v-model="mteType.isMaster" />
        </b-field>
      </div>
    </div>
    <footer class="card-footer detached">
      <b-button @click="cancel()" outlined :loading="waitingForWrite">{{
        $t('cancel')
      }}</b-button>
      <b-button
        @click="save()"
        type="is-info"
        :disabled="!fieldsAreValid || isLoading"
        >{{ isNew ? $t('create') : $t('update') }}</b-button
      >
    </footer>
  </div>
</template>
<script>
import store from '../../store/index';

export default {
  data() {
    return {
      mteType: {
        name: '',
        needsMaster: false,
        isMaster: false,
      },
      isLoading: false,
    };
  },
  computed: {
    isNew() {
      return !this.mteType._id;
    },
    waitingForWrite() {
      return this.$store.state.waitingForWrite;
    },
    fieldsAreValid() {
      if (this.mteType.name === '') return false;
      return true;
    },
  },
  async beforeRouteEnter(to, {}, next) {
    const idToLoad = to.params ? to.params.id : null;
    if (idToLoad) {
      await store.dispatch('getMteType', idToLoad);
    }
    next();
  },
  created() {
    if (this.$route.params && this.$route.params.id) {
      this.mteType = this.$store.state.mteType;
    }
  },
  methods: {
    cancel() {
      this.$router.replace({ name: 'admin-root' });
    },
    async save() {
      if (this.fieldsAreValid) {
        this.isLoading = true;
        await this.$store.dispatch('saveMteType', this.mteType);
        this.$router.replace({ name: 'admin-root' });
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card.centered {
  width: 90%;
  margin: 20px auto;
}
.card-content-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  & > * {
    flex: 1 1 auto;
    margin: 0;
  }
}
.card-footer.detached {
  display: flex;
  position: fixed;
  bottom: 5%;
  right: 0;
  margin-right: 5%;
  gap: 10px;
  & > * {
    width: 100px;
  }
  button:disabled,
  button[disabled] {
    border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
  }
}
</style>
